export default {
  register: "ลงทะเบียน",
  welcome: "ยินดีต้อนรับสู่ระบบ",
  textWelcome: "ยินดีต้อนรับ",
  textGoodMorning: "อรุณสวัสดิ์",
  textGoodAfternoon: "สวัสดีตอนบ่าย",
  textGoodEvening: "สวัสดีตอนเย็น",
  textGoodNight: "ราตรีสวัสดิ์",
  loginFail: "เข้าสู่ระบบไม่สำเร็จ",
  phone: "เบอร์โทรศัพท์",
  email: "อีเมล",
  agreeTermAndCondition: "ยอมรับนโยบายความเป็นส่วนตัว",
  pleaseAgreeTermAndCondition: "กรุณายอมรับนโยบายความเป็นส่วนตัว",
  back: "ย้อนกลับ",
  termAndCondition: "เงื่อนไขการใช้บริการ",
  termAndCondition2: "ข้อกำหนดและเงื่อนไข",
  cancel: "ยกเลิก",
  confirm: "ตกลง",
  confirmDefault: "ยืนยัน",
  confirmRegistration: "ยืนยันลงทะเบียน",
  addItem: "เพิ่มรายการ",
  required: "กรุณากรอกข้อมูล",
  zipcode: "รหัสไปรษณีย์",
  sub_district: "แขวง / ตำบล",
  district: "เขต / อำเภอ",
  province: "จังหวัด",
  save: "บันทึก",
  saveDraft: "บันทึกฉบับร่าง",
  close: "ปิด",
  name: "ชื่อ",
  surname: "นามสกุล",
  birthDay: "วันเกิด",
  gender: "เพศ",
  educationLevel: "ระดับการศึกษา",
  jobLevel: "ระดับตำแหน่งงาน",
  jobPosition: "ตำแหน่งงาน",
  department: "แผนก",
  company: "บริษัท",
  address: "ที่อยู่",
  enterRegister: "ลงทะเบียน",
  management: "Management",
  manager: "Manager",
  supervisor: "Supervisor",
  officer: "Officer / Staff",
  worker: "Worker / Operator",
  doctorate: "ปริญญาเอก",
  masterDegree: "ปริญญาโท",
  bachelorDegree: "ปริญญาตรี",
  highVocational: "ปวส.",
  technicalVocational: "ปวท.",
  vocational: "ปวช.",
  highSchool: "มัธยมปลาย",
  secondarySchool: "มัธยมต้น",
  primarySchool: "ประถมศึกษา",
  lowerPrimary: "ต่ำกว่าประถมศึกษา",
  male: "ชาย",
  female: "หญิง",
  other: "อื่นๆ",
  profile: "ข้อมูลส่วนตัว",
  id: "รหัสประจำตัว",
  nameSurname: "ชื่อ-นามสกุล",
  sendRefCodeOtp: "ส่ง OTP รหัส",
  requestOtpAgain: "ขอรหัสอีกครั้ง",
  edit: "แก้ไข",
  add: "เพิ่ม",
  addressSendReward: "ที่อยู่จัดส่งของรางวัล",
  addressDetail: "รายละเอียดที่อยู่",
  selectDefautAddress: "ตั้งค่าที่อยู่นี้เป็นค่าเริ่มต้น",
  addressEdit: "แก้ไขที่อยู่",
  addressAdd: "เพิ่มที่อยู่",
  defaultValue: "ค่าเริ่มต้น",
  hello: "สวัสดี คุณ",
  coinTotal: "จำนวนคะแนนของคุณ",
  homePage: "หน้าแรก",
  activityPage: "ร่วมกิจกรรม",
  redemptPage: "แลกของรางวัล",
  invitePage: "เชิญเพื่อน",
  connectPlatformPage: "เชื่อมต่อ Platform",
  connectPlatformPageHint: "E-Commerce เพื่อรับสิทธิพิเศษ",
  birthDayPage: "รับของขวัญวันเกิด",
  addressPage: "ที่อยู่จัดส่งของรางวัล",
  favoritePage: "รายการโปรด",
  cancelShipment: "สถานะยกเลิกการจัดส่ง",
  couponPage: "คูปองของฉัน",
  myLuckyDrawPage: "สิทธิ์ลุ้นโชคของฉัน",
  myMemberPage: "สมาชิกของฉัน",
  registerMemberPage: "ลงทะเบียนสมาชิก",
  statusDeliveryPage: "เช็คสถานะจัดส่งของรางวัล",
  transferPage: "โอนคะแนน",
  logout: "ออกจากระบบ",
  textCategory: "หมวดหมู่",
  categoryAll: "ทั้งหมด",
  categoryRecommend: "แนะนำ",
  categoryFood: "อาหาร",
  categoryElectrical: "เครื่องใช้ไฟฟ้า",
  categoryAppliance: "เครื่องใช้ในบ้าน",
  categoryOther: "อื่นๆ",
  totalValue: "จำนวนที่เหลือ",
  detail: "รายละเอียด",
  seeMoreDetail: "ดูรายละเอียด",
  youWant: "คุณต้องการ",
  delete: "ลบ",
  favoriteText: "ในรายการโปรด",
  waitingLoad: "กรุณารอสักครู่",
  expireTime: "หมดเขตแล้ว",
  coin: "คะแนน",
  surveyRegister: "แบบสอบถามการลงทะเบียน",
  later: "ภายหลัง",
  redeem: "แลกของรางวัล",
  redeemPoint: "แลก",
  confirmRedeem: "ยืนยันการแลกรางวัล",
  confirmAdd: "คุณต้องการเพิ่ม",
  inYourFav: "ในรายการโปรด",
  confirmDelete: "คุณต้องการลบ",
  fromYourFav: "ออกจาก รายการโปรด ",
  balance: "จำนวนคงเหลือ",
  inviteFrindDetail: "เพียงกดชวนเพื่อนมาใช้แอพ เมื่อเพื่อนลงทะเบียนสำเร็จ ",
  received: "ได้รับ",
  inviteFriend: "ชวนเพื่อน",
  inviteFriendPhoneText: "กรอกเบอร์โทรศัพท์ที่ต้องการเชิญเพื่อน",
  inviteFriendLineText: "ชวนเพื่อน ผ่าน Line",
  fillPhone: "กรอกเบอร์โทรศัพท์เพื่อน",
  historyRedeem: "ประวัติการสะสมคะแนน",
  historyCode: "ประวัติการส่งรหัส",
  resendCode: "ส่งรหัสใหม่",
  coinAll: "ทั้งหมด",
  coinReceived: "คะแนนที่ได้รับ",
  coinUsed: "คะแนนที่ใช้ไป",
  activityAll: "กิจกรรมทั้งหมด",
  expireDate: "หมดเขตวันที่",
  note: "หมายเหตุ",
  enterNote: "ระบุหมายเหตุ...",
  checkIn: "เช็คอิน",
  activityExpireDate: "วันสิ้นสุดกิจกรรม",
  collectCoin: "สะสมคะแนน",
  valueItem: "มูลค่า",
  missionReward: "รางวัลจากกิจกรรม",
  activityJoin: "เข้าร่วมกิจกรรม",
  activityQr: "สแกน QR Code",
  activitySurvey: "เข้าร่วมกิจกรรม",
  activityUpload: "ส่งข้อมูล",
  activityScanQr: "สแกน QR",
  scanCode: "สแกนรหัส",
  sendSurvey: "ส่งแบบทดสอบ",
  uploadFile: "Upload File",
  sizeFile: "ขนาดไฟล์ไม่เกิน 10 MB",
  activityStatusJoin: "กิจกรรมที่กำลังเข้าร่วม",
  activityStatusWait: "กิจกรรมที่รออนุมัติ",
  activityStatusSuccess: "กิจกรรมที่สำเร็จ",
  activityStatusReject: "กิจกรรมที่ไม่สำเร็จ",
  activityStatusAll: "กิจกรรมทั้งหมด",
  registerToReceive: "ลงทะเบียนเพื่อรับสิทธิ์",
  confirmUseCoupon: "ยืนยันการใช้คูปอง",
  noteUseCoupon:
    "แนะนำให้กดสิทธิ์เมื่ออยู่ที่ร้านค้าแล้ว เพื่อป้องกันไม่ให้เสียสิทธิ์",
  noteAlertUseCoupon: "รหัสจะถือว่าใช้แล้วทันที หลังกดรับสิทธิ์",
  codeDiscount: "โค้ดส่วนลด",
  errorQr: "กรุณาติดต่อเจ้าหน้าที่ผู้ดูแลระบบ",
  cancelRedemption: "คุณต้องการยกเลิก การทำรายการ? ",
  cancelRedemptionNote: "โดยจะไม่ได้รับคะแนนคืนในการยกเลิก",
  statusDelivery: "สถานะจัดส่งของรางวัล",
  statusSendIn7Day: "จัดส่งภายใน 7 วัน",
  shippingInProcess: "อยู่ระหว่างดำเนินการ",
  statusDeliverySuccess: "จัดส่งสำเร็จแล้ว",
  statusDeliveryCancel: "ยกเลิกการจัดส่ง",
  trackingNumber: "หมายเลขติดตามพัสดุ",
  receiveReward: "รับของรางวัล",
  copyText: "คัดลอกแล้ว",
  confirmReceiveReward: "ยืนยันการรับของรางวัล",
  activitySuggest: "กิจกรรมแนะนำ",
  pageNotFound: "ไม่พบหน้าที่ต้องการ",
  goBackPage: "ย้อนกลับ",
  goToLogin: "ไปที่หน้าเข้าสู่ระบบ",
  changeLanguage: "เปลี่ยนภาษา",
  all: "ทั้งหมด",
  join: "กำลังเข้าร่วม",
  joined: "เข้าร่วม",
  success: "สำเร็จ",
  failed: "ไม่สำเร็จ",
  waiting: "รออนุมัติ",
  pending: "ยังไม่จัดส่ง",
  sent: "จัดส่งแล้ว",
  delivered: "จัดส่งสำเร็จ",
  textRequireOTPAgain: "ขอรหัส OTP ใหม่อีกครั้งภายใน : ",
  welcomeActivity: "ยินดีต้อนรับการร่วมสนุก",
  errQr: "รหัส QR Code ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
  requireExam: "กรุณากรอกแบบสอบถามให้ครบ",
  uploadSuccess: "ส่งผลลัพธ์เรียบร้อยแล้ว",
  uploadWaiting: "จะดำเนินการตรวจสอบภายใน 7 วัน",
  errDupActivity: "คุณได้ทำกิจกรรมนี้แล้ว กรุณาเลือกกิจกรรมอื่น",
  errExpireActivity: "ขออภัยค่ะ กิจกรรมหมดเวลาไปเรียบร้อยแล้ว",
  errActivity: "ขออภัยค่ะ ไม่สามารถร่วมกิจกรรมนี้ได้",
  errFileUpload: "ขนาดไฟล์ไม่ควรเกิน 10 MB",
  errMyLuckyDrawNotEnough: "ขออภัยค่ะ จำนวนสิทธิ์คงเหลือไม่เพียงพอ",
  expireDateUse: "หมดเขต",
  registerPage: "ไปหน้าลงทะเบียน",
  shareActivity: "แชร์กิจกรรม",
  goToMission: "ดูกิจกรรมทั้งหมด",
  menuActivity: "กิจกรรม",
  menuRedeem: "แลกของรางวัล",
  menuCoupon: "คูปองของฉัน",
  privacyPolicy: "นโยบายความเป็นส่วนตัว",
  favoriteCategory: "รายการโปรด",
  deviceCategory: "เครื่องใช้ไฟฟ้า",
  accessoryCategory: "อุปกรณ์อิเล็กทรอนิกส์",
  healthCategory: "สุขภาพและความงาม",
  foodCategory: "อาหารและเครื่องดื่ม",
  babyCategory: "เด็กและของเล่น",
  petCategory: "สัตว์เลี้ยง",
  homeCategory: "บ้านและไลฟ์สไตล์",
  menCategory: "แฟชั่นผู้ชาย",
  womenCategory: "แฟชั่นผู้หญิง",
  sportCategory: "กีฬา",
  travelCategory: "ท่องเที่ยว",
  reward: "รางวัล",
  missionComing: "กิจกรรมที่กำลังจะมา",
  startDate: "วันที่เริ่ม",
  endDate: "วันที่สิ้นสุด",
  home: "หน้าหลัก",
  activity: "กิจกรรม",
  tracking: "ติดตาม",
  account: "บัญชี",
  historyCoupon: "ประวัติการใช้คูปอง",
  rewardSoHot: "รางวัลสุดฮอต",
  hotMission: "กิจกรรม กำลังมาแรง",
  recommendMission: "กิจกรรม แนะนำ",
  doneDetailMission: "รายละเอียดการเข้าร่วมกิจกรรม",
  detailMission: "รายละเอียดกิจกรรม",
  newActivityUpload: "ส่งข้อมูลอีกครั้ง",
  errNotTimeForActivity: "ยังไม่ถึงเวลาเล่นกิจกรรม",
  news: "ข่าวสาร",
  birthDayGift: "ของขวัญวันเกิด",
  friendRecommend: "เพื่อนแนะนำ",
  friendRequest: "คำร้องขอ",
  friendList: "เพื่อนของฉัน",
  rewardLimitReached: "สิทธิ์เต็มแล้ว",
  limitReached: "สิทธิ์เต็มแล้ว",
  limitReachedPerDay: "สิทธิ์รายวันเต็มแล้ว",
  textComingSoon: "เร็วๆนี้",
  textTimeCannotJoin: "อยู่นอกช่วงเวลากิจกรรม",
  couponExpired: "คูปองหมดอายุ",
  myLuckyDrawExpire: "หมดอายุแล้ว",
  conditionCoin: "ตามเงื่อนไข",
  rewardPrize: "ของรางวัล",
  agree: "ยินยอม",
  disagree: "ไม่ยินยอม",
  activityHeartToHeart: "ส่งข้อความ",
  rewardComingSoon: "เร็วๆนี้",
  addMember: "เพิ่มสมาชิก",
  conditionEntryPass: "เงื่อนไขการเข้าร่วม",
  letsJoin: "เข้าร่วม",
  isUsed: "ถูกใช้งานแล้ว",
  editProfile: "แก้ไขโปรไฟล์",
  textProfile: "โปรไฟล์",
  searchMissionOrReward: "ค้นหา กิจกรรม หรือ รางวัล",
  searchHistory: "ประวัติการค้นหา",
  removeSearchHistory: "ลบประวัติการค้นหา",
  messageActivityUpcoming: "อดใจรอสักครู่ กิจกรรมกำลังมาเร็วๆนี้ 🎉",
  messageActivityErrorReJoin:
    "เกิดข้อผิดพลาดในการร่วมกิจกรรม\nกรุณากดเข้าร่วมจากหน้ากิจกรรม",
  errActivityAlreadyJoined: "ขออภัยค่ะ คุณได้ร่วมกิจกรรมแล้ว",
  errActivityDataNotFound: "ขออภัยค่ะ ไม่พบข้อมูลการเข้าร่วมกิจกรรม",
  redeemSuccessWithClaimInstruction:
    "แลกของรางวัลสำเร็จ กรุณากดรับของรางวัลที่หน้าของรางวัลของฉัน",
  redeemSuccess: "แลกของรางวัลสำเร็จ",
  errRewardOutOfStock: "ขออภัยค่ะ ของรางวัลหมดแล้ว",
  errRedeemFail: "ขออภัยค่ะ แลกของรางวัลไม่สำเร็จ",
  textSorry: "ขออภัยค่ะ",
  errDataNotFound: "ขออภัยค่ะ ไม่พบข้อมูล",
  errSubmissionFailed: "ขออภัยค่ะ ส่งข้อมูลไม่สำเร็จ",
  errRegistrationFailedContactAdmin:
    "ลงทะเบียนไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่ผู้ดูแลระบบ",
  btnRedirectMyCoupon: "ไปที่หน้าคูปองของฉัน",
  infoCouponReadyMyCoupons: "สามารถใช้งานคูปองที่หน้า คูปองของฉัน",
  coinCost: "จำนวนคะแนนที่ใช้",
  next: "ถัดไป",
  skip: "ข้าม",
  otpVerified: "ยืนยัน OTP",
  successOTPVerified: "ยืนยัน OTP สำเร็จ",
  dataNotFound: "ไม่พบข้อมูล",
  version: "เวอร์ชัน",
  viewAll: "ดูทั้งหมด",
  availableStock: "จำนวนคงเหลือ",
  expiredAt: "จะหมดอายุใน",
  expiredAt2: "หมดอายุเมื่อ",
  rewardToReceive: "ของรางวัลที่จะได้รับ",
  chooseRewardToReceive: "เลือกของรางวัลที่จะได้รับ",
  viewResultActivity: "ดูผลลัพธ์กิจกรรม",
  titleInvite:
    "{name} ได้ส่งคำเชิญให้คุณ เข้าร่วมกิจกรรมสะสมคะแนน และรับสิทธิพิเศษมากมาย",
  thankYouForParticipatingActivity: "ขอบคุณที่ร่วมกิจกรรม",
  doActivityBy: "ทำกิจกรรมโดย",
  textNotSpecified: "ไม่ระบุ",
  textIncognito: "โหมดไม่ระบุตัวตน",
  viewHistory: "ดูประวัติ",
  history: "ประวัติ",
  locationName: "ชื่อสถานที่",
  location: "สถานที่",
  selectRedeemRewardLocation: "เลือกที่อยู่การรับของรางวัล",
  selectAddressSendReward: "เลือกที่อยู่ในการจัดส่ง",
  instructionAddAddressSendReward: "กรุณาเพิ่มที่อยู่ในการจัดส่ง",
  textSelect: "เลือก",
  instructionEnterRegisteredPhone:
    "กรณีเคยลงทะเบียนแล้ว กรุณากรอกเบอร์โทรศัพท์ที่เคยลงทะเบียนไว้",
  instructionEnterRegisteredEmail:
    "กรณีเคยลงทะเบียนแล้ว กรุณากรอกอีเมลที่เคยลงทะเบียนไว้",
  textFirstRegistration: "ลงทะเบียนครั้งแรก",
  textClickHere: "กดที่นี่",
  statusRegistrationSuccess: "ลงทะเบียนสำเร็จ",
  statusRegistrationFailed: "ลงทะเบียนไม่สำเร็จ",
  instructionUploadIDPassport: "กรุณาแนบไฟล์ภาพบัตรประชาชน / พาสปอร์ต",
  textUploadIDPassport: "แนบไฟล์ภาพบัตรประชาชน / พาสปอร์ต",
  rewardStartDate: "วันเริ่มแลกของรางวัล",
  rewardExpiredDate: "วันหมดเขตของรางวัล",
  detailMyLuckyDraw: "รายละเอียดสิทธิ์",
  date: "วันที่",
  errUserNotFound: "ขออภัยค่ะ ไม่พบข้อมูลผู้ใช้งาน",
  textSelectUser: "เลือกผู้ใช้งาน",
  textSelectFile: "เลือกไฟล์",
  textImageType: "รูปภาพ",
  textVideoType: "วิดีโอ",
  instructionSelectOrAddAddress:
    "กรุณาเลือกที่อยู่จัดส่ง หรือ เพิ่มที่อยู่จัดส่ง",
  instructionSelectRewardMission: "กรุณาเลือกของรางวัลจำนวน {amount} ชิ้น",
  textTopRanking: "อันดับสูงสุด",
  textRank: "อันดับ",
  textTotalAmount: "จำนวนรวมทั้งหมด",
  viewProfile: "ดูโปรไฟล์",
  addFriend: "เพิ่มเพื่อน",
  cancelFriend: "เลิกเป็นเพื่อน",
  removeFriendSuccess: "ลบเพื่อนสำเร็จ",
  instructionUploadImageVideo: "อัพโหลด รูปภาพ/วีดิโอ (ไม่เกิน {size} MB)",
  textUnsupportedFileType: "ไม่รองรับประเภทไฟล์นี้",
  textAdditionalDescription: "คำอธิบายเพิ่มเติม",
  textDescription: "คำอธิบาย",
  textLocationOrBranchName: "ชื่อสถานที่ / สาขา",
  textCheckInTime: "เวลาเช็คอิน",
  textCheckOutTime: "เวลาเช็คเอ้าท์",
  textLastUpdate: "อัปเดตล่าสุด",
  instructionLineReopenExternalBrowser:
    "จำเป็นต้องเปิดเว็บบราวเซอร์จากไลน์อีกครั้ง เพื่อเข้าสู่ระบบ",
  errPhoneIsUsed: "ขออภัยค่ะ เบอร์โทรศัพท์นี้ถูกใช้งานแล้ว",
  textConditionEntryPassGamification: "สิ่งที่ต้องใช้",
  textFree: "ฟรี",
  textCongratsReceived: "ยินดีด้วย 🎉 คุณได้รับ",
  happyBirthMonth: "สุขสันต์เดือนเกิด",
  happyBirthMonthWish:
    "ขอให้วันนี้เป็นวันที่พิเศษ เต็มไปด้วยความสุข รอยยิ้ม และของขวัญที่คุณสมควรได้รับ 🎁 ขอให้มีแต่เรื่องดีๆ เข้ามาทั้งปีเลยนะ!",
  confirmDeleteMember: "คุณต้องการลบสมาชิก {name} ?",
  removeMemberSuccess: "ลบสมาชิกสำเร็จ",
  removeMemberFail: "ลบสมาชิกไม่สำเร็จ",
  confirmEditProfile: "คุณต้องการแก้ไขข้อมูลส่วนตัว ?",
  bonusCoin: "คะแนนโบนัส",
  receiveCoin: "คุณได้รับคะแนน",
  status: "สถานะ",
  checkSendCodeHistory: "สามารถใช้งานคูปองที่หน้า คูปองของฉัน",
  errTimeOut: "ขออภัยค่ะ เวลาได้หมดลงแล้ว",
  inviteHeadline: "ยิ่งเพื่อนเยอะ ยิ่งสนุก!",
  inviteFriendNow: "กดชวนเพื่อนมาใช้แอพได้เลย",
  copyInviteLink: "คัดลอกคำเชิญ",
  copyInviteLinkSuccess: "คัดลอกคำเชิญเรียบร้อย",
  detailScanQrCode: "กรุณาให้ตำแหน่ง QR Code อยู่ตรงกลางภาพ",
  pleaseFill: "กรุณากรอก",
  comment: "ความคิดเห็น",
  claimSpecialGift: "รับของขวัญสุดพิเศษ",
  claimGift: "รับของขวัญ",
  claimGiftSuccess: "รับของขวัญสำเร็จ",
  list: "รายการ",
  summary: "ภาพรวม",
  collected: "สะสม",
  collectedItemCount: "สะสมครบ {count} รายการ",
  invalidPhoneNumber: "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง",
  duplicateData: "ข้อมูลซ้ำ",
  saveSuccess: "บันทึกข้อมูลสำเร็จ",
  uploadSuccessful: "อัพโหลดสำเร็จ",
  memberLevel: "ระดับปัจจุบัน",
  maxLevelReached: "ยินดีด้วย! คุณมาถึงระดับสูงสุดแล้ว 🎉",
  // earnMoreForNextLevel:
  //   "สะสมอีก {nextLevelEarn} คะแนน เพื่อเข้าสู่ {nextLevelName}",
  earnMoreForNextLevel: "สะสมอีก {nextLevelEarn} เพื่อเข้าสู่ {nextLevelName}",
  code: "รหัส",
  codeNo: "รหัสที่ {no}",
  qrCode: "QR Code",
  barCode: "Barcode",
  removeCache: "ลบข้อมูลแคช",
  connect: "เชื่อมต่อ",
  luckyDrawCount: "จำนวนสิทธิ์",
  locationAccessDenied:
    "ไม่สามารถระบุตำแหน่งของคุณได้ กรุณาอนุญาตให้เข้าถึงตำแหน่ง",
  viewing: "กำลังดู",
  cameraError: {
    notAllowed: "กรุณาอนุญาตให้เข้าถึงกล้องเพื่อใช้งาน",
    notFound: "ข้อผิดพลาด: ไม่พบกล้องติดตั้งอยู่ในอุปกรณ์นี้",
    notSupported:
      "ข้อผิดพลาด: ต้องใช้งานผ่านการเชื่อมต่อที่ปลอดภัย (HTTPS หรือ localhost)",
    notReadable: "ข้อผิดพลาด: กล้องกำลังถูกใช้งานโดยโปรแกรมอื่นอยู่หรือไม่?",
    overconstrained: "ข้อผิดพลาด: กล้องที่มีอยู่ไม่รองรับการตั้งค่าที่ระบุ",
    streamApiNotSupported: "ข้อผิดพลาด: เบราว์เซอร์นี้ไม่รองรับระบบ Stream API",
    insecureContext:
      "ข้อผิดพลาด: การเข้าถึงกล้องอนุญาตเฉพาะในระบบที่ปลอดภัยเท่านั้น กรุณาใช้ HTTPS แทน HTTP",
    unknown: "ข้อผิดพลาด: เกิดปัญหาในการใช้งานกล้อง ({error_name})",
  },
  error: {
    title: "เกิดข้อผิดพลาด!",
    general: "เกิดข้อผิดพลาดบางอย่าง กรุณาลองใหม่อีกครั้ง",
    unknown: "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ",
    network: "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบอินเทอร์เน็ตของคุณ",
    timeout: "การเชื่อมต่อใช้เวลานานเกินไป",
    notFound: "ขออภัย ไม่พบข้อมูลที่คุณต้องการ",
    unauthorized: "คุณไม่มีสิทธิ์เข้าถึงส่วนนี้",
    sessionTimeout:
      "ขออภัยค่ะ เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
    heicNotSupported:
      "ไม่รองรับไฟล์ HEIC/HEIF กรุณาใช้ไฟล์ JPG หรือ PNG",
    imageSupported: "รองรับเฉพาะไฟล์ JPG, JPEG และ PNG เท่านั้น",
    ocrProductNotFound: "ไม่พบข้อมูลสินค้าที่ตรงกับฉลากนี้ในระบบ",
  },
  yourCodeIs: "รหัสของคุณคือ",
  validation: {
    required: "กรุณาระบุข้อมูล",
    phoneInvalid: "หมายเลขโทรศัพท์ไม่ถูกต้อง",
    emailInvalid: "อีเมลไม่ถูกต้อง",
    enterOTP: "กรุณากรอกรหัส OTP",
    otpInvalid: "รหัส OTP ต้องมี 6 หลัก",
    uploadLimit: "ไม่ควรใส่เกิน {number} จำนวน",
    numberInvalid: "กรุณากรอกตัวเลข",
    minCode: "กรุณากรอกรหัสอย่างน้อย 1 รหัส",
    maxFilesAllowed: "คุณสามารถอัปโหลดได้สูงสุด {count} ไฟล์เท่านั้น",
    invalidFileFormat: "รูปแบบไฟล์ไม่ถูกต้อง กรุณาอัปโหลดไฟล์ใหม่อีกครั้ง",
  },
  redeemAmount: "จำนวนที่ต้องการจะแลก: {quantity}",
  duration: "ระยะเวลา",
  webAccessDenied: "คุณไม่มีสิทธิ์เข้าถึง website นี้",
  webRedirecting: "กำลังไปยัง website ที่ถูกต้อง",
  or: "หรือ",
  notEnough: "ไม่เพียงพอ",
  notAvailable: "ไม่พร้อมใช้งาน",
  amount: "จำนวน",
  message: "ข้อความ",
  loginLineLoading: "กำลังเข้าสู่ระบบผ่าน Line...",
  signinWithLine: "ลงชื่อเข้าใช้ด้วย Line",
  signinWithGoogle: "ลงชื่อเข้าใช้ด้วย Google",
  sampleImage: "ตัวอย่างภาพ",
  submitResult: "ส่งผลลัพธ์",
  submit: "ยืนยัน",
  unit: {
    km: "กิโลเมตร",
    cc: "ซีซี",
    unit: "หน่วย",
  },
  menuMain: "เมนูหลัก",
  menuMore: "เพิ่มเติม",
  menuChatRoom: "กล่องข้อความ",
  menuInformationCenter: "ศูนย์ข้อมูล",
  menuInformationCenterFull: "ศูนย์ข้อมูล",
  menuCampaign: "แคมเปญ",
  menuRequest: "คำร้อง",
  menuWarranty: "การรับประกัน",
  joinedCampaigns: "แคมเปญที่เข้าร่วม",
  campaignTotalPoint: "สิทธิ์ทั้งหมด",
  campaignTotalAmount: "ยอดทั้งหมด",
  allRequest: "คำร้องทั้งหมด",
  newRequest: "สร้างคำร้องใหม่",
  textFilter: "ตัวกรอง",
  textSortBy: "เรียงตาม",
  textUpdated: "อัปเดต",
  textAttachmentCount: "ไฟล์แนบ {count} รายการ",
  textAttachmentFile: "ไฟล์แนบ",
  textFilePreview: "ตัวอย่างไฟล์",
  textReply: "ตอบกลับ",
  textReplyForm: "ตอบกลับแบบฟอร์ม",
  textForm: "แบบฟอร์ม",
  textFillInForm: "กรอกแบบฟอร์ม",
  textPost: "โพสต์",
  textInputComment: "แสดงความคิดเห็น",
  textViewMoreComment: "ดูความคิดเห็นเพิ่มเติม",
  textViewMoreReply: "ดูการตอบกลับเพิ่มเติม",
  textRewardCount: "{count} รายการ",
  filterAll: "ทั้งหมด",
  filterFavorite: "รายการโปรด",
  filterUnread: "ยังไม่ได้อ่าน",
  filterNoType: "ไม่ระบุประเภท",
  filterReportStatus: "สถานะ : {report_status_name}",
  sortDate: "เรียงตามวันที่",
  sortTitle: "เรียงตามหัวข้อ",
  sortExpiredDate: "เรียงตามวันที่หมดอายุ",
  sortProduct: "เรียงตามสินค้า",
  sortRegisterDate: "เรียงตามวันที่ลงทะเบียน",
  clear: "ล้าง",
  addFavorite: "เพิ่มไปยังรายการโปรด",
  removeFavorite: "นำออกจากรายการโปรด",
  extraBonus: "โบนัสเพิ่มเติม",
  deliveryPickup: "รับที่จุดรับของ",
  deliveryThailandPost: "ไปรษณีย์ไทย",
  pleaseFillDetail: "กรุณากรอกรายละเอียด ...",
  textTitle: "หัวเรื่องหลัก",
  textSubtitle: "หัวเรื่องย่อย",
  textType: "ประเภท",
  textProduct: "สินค้า",
  hintUploadMultiFile:
    "อัปโหลดได้สูงสุด {fileLimit} ไฟล์, ขนาดรวมทั้งหมดไม่เกิน {fileLimitMB} MB",
  errorUploadLimitFileSize: "ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน {fileLimitMB} MB",
  specialReward: "รับรางวัลสุดพิเศษของคุณได้เลย!",
  totalSummaryPoint: "คะแนนรวม",
  transferPoint: "โอนคะแนน",
  confirmTransferPoint: "คุณต้องการโอน {point} ให้กับ {name} ?",
  transferSuccess: "โอนคะแนนสำเร็จ",
  transferDescription: "โอนคะแนนให้ผู้ใช้อื่นภายในระบบ",
  selectRecipient: "เลือกผู้รับ",
  selectMember: "เลือกสมาชิก",
  enterTransferPoints: "กรอกจำนวนคะแนนที่จะโอน",
  transferPointAmount: "จำนวนคะแนนที่ต้องการโอน",
  transferPointType: "ประเภทคะแนนที่ต้องการโอน",
  transferPoints: "โอนคะแนน",
  totalPoint: "คะแนนของคุณ",
  myPointAll: "ทั้งหมด",
  myPointExpire: "กำลังจะหมดอายุ",
  myPointExchange: "แลกเปลี่ยน",
  total: "ทั้งหมด",
  toMember: "ให้กับ",
  remaining: "คงเหลือ",
  max: "สูงสุด",
  allWarranty: "การรับประกันทั้งหมด",
  warranty: "การรับประกัน",
  warrantyRegistration: "ลงทะเบียนรับประกัน",
  newProductWarranty: "สินค้าชิ้นใหม่",
  registerWarrantyDescription: "ลงทะเบียนการซื้อของคุณเพื่อเปิดใช้งานการรับประกัน",
  registerNow: "ลงทะเบียนทันที",
  serviceRequest: "คำขอรับบริการ",
  warrantyStatus: {
    active: "ใช้งานอยู่",
    pending: "รอตรวจสอบ",
    rejected: "ไม่อนุมัติ",
    expired: "หมดอายุ",
  },
  textUploadProductLabel: "อัพโหลดฉลากสินค้า",
  textAutoFillByAI: "เพื่อกรอกข้อมูลอัตโนมัติด้วย AI ✨",
  textBtnSelectPhoto: "เลือกรูปภาพ",
  textViewSamplePhoto: "ดูรูปภาพตัวอย่าง",
  textNumberMore: "+{number} รายการ",
  textHide: "ซ่อน",
  microsite: {
    invalidPhoneNumber: "Please enter a valid phone number",
    otpVerified: "Confirm OTP",
    sendRefCodeOtp: "Ref OTP",
    textRequireOTPAgain: "Request a new OTP code again within : ",
    requestOtpAgain: "Request OTP Again",
    confirmDefault: "Confirm",
    enterOTP: "Please enter the OTP",
    otpInvalid: "OTP must be 6 digits",
    textTransactionDetail: "Transaction Detail",
    createdAt: "Date",
    summary_amount: "Summary Amount",
    point: "Point",
    status: "Status",
    status_detail: "Status Detail",
    item_name: "Item Name",
    item_image: "Item Image",
    Approved: "Approved",
    Waiting: "Waiting Approval",
    Rejected: "Rejected",
    Pending: "Pending",
    privacyPolicy: "Privacy<br />policy",
    termAndCondition: "Terms &<br />conditions",
    textNext: "Next",
    acceptConsent: "I accept",
    dataNotFound: "Data Not Found",
    maxFileSizeAllowed: "File Size is less than {size} MB.",
    maxFilesAllowed: "You can upload maximum {count} files",
    errSubmissionFailed: "Sorry, your submission failed.",
    errGeneral: "Something went wrong. Please try again.",
    successOTPVerified: "OTP Verified successfully",
    textBack: "Back",
    errActivityAlreadyJoined: "Sorry, you have already joined this activity.",
    textRefresh: "Refresh",
    errActivity: "Sorry, you cannot join this activity.",
    textRegistrationHistory: "REGISTRATION HISTORY",
    textTotalPoint: "Total point",
    textTotalAmount: "Total amount",
    textHistory: "HISTORY",
    textNo: "No",
    textCode: "Code",
    textSuccess: "Success",
    textNotFound: "Not Found",
    textUsed: "Used",
    errUserNotFound: "Sorry, user not found.",
    loginSuccess: "Login successful.",
    registerSuccess: "Register successful.",
    textResultsSummary: "Results Summary",
    textTopRankingCampaign: "Top {num} Ranking",
    textRank: "Rank",
    textPhone: "Phone Number",
    textTotal: "Total",
    textLuckyDrawClaimed:
      "You have already claimed your Lucky Draw rights for this campaign.",
    textContactAdminToChange:
      "To change your selection, please contact administrator.",
    textConnectWithLine: "Connect with LINE",
    textBackHome: "Home",
  },
};
